import React from 'react';
import { useTranslation } from 'react-i18next';
import ColorTag, { ColorTagColor } from './ColorTag';
import { RoleType } from '../../types/user/accounts/RoleType';

const ROLE_COLOR: Record<RoleType, ColorTagColor> = {
  OWNER: 'grey-dark',
  ADMIN: 'blue',
  USER: 'grey',
  GUEST: 'grey',
};

const ROLE_LABEL_KEY: Record<RoleType, string> = {
  OWNER: 'owner',
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest',
};

/** Role shown as a coloured `ColorTag` (owner / admin / user / guest). Accepts a plain
 *  string and falls back gracefully for unknown roles. */
const RoleTag: React.FC<{ role: string }> = ({ role }) => {
  const { t } = useTranslation();
  const color = ROLE_COLOR[role as RoleType] ?? 'grey';
  const labelKey = ROLE_LABEL_KEY[role as RoleType];
  return <ColorTag color={color}>{labelKey ? t(labelKey) : role}</ColorTag>;
};

export default RoleTag;
